import { useFormik } from "formik";
import React from "react";
import toast from "react-hot-toast";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import FaqService from "../../../services/KangarooServices/FaqService";
import * as Yup from "yup";

const GroupForm = ({ isOpen, toggle, fetchCustomers, selectedItem }) => {
  const formik = useFormik({
    initialValues: {
      name: selectedItem?.name || "",
      order: selectedItem?.order || "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Question is required")
        .min(3, "Question must be at least 3 characters"),

      order: Yup.string().required("Order is required"),
    }),

    onSubmit: async (values) => {
      try {
        if (selectedItem?.id) {
          await FaqService.updateGroup(selectedItem?.id, values);
          toast.success("Update successful");
        } else {
          await FaqService.createGroup(values);
          toast.success("Create successful");
        }
        fetchCustomers();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong");
      }
    },
  });
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>FAQ Group</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>
              Name <span className="text-danger">*</span>
            </Label>
            <Input
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="text-danger mt-1">{formik.errors.name}</div>
            )}
          </div>
          <div className="mb-3">
            <Label>
              Order <span className="text-danger">*</span>
            </Label>
            <Input
              name="order"
              value={formik.values.order}
              onChange={formik.handleChange}
            />
            {formik.touched.order && formik.errors.order && (
              <div className="text-danger mt-1">{formik.errors.order}</div>
            )}
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-success" type="submit">
              {selectedItem?.id ? "Update" : "Save"}
            </button>
            <button className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default GroupForm;
